import hasFloatValidDigits from '~/utils/Number/hasFloatValidDigits';

export default function isFactorValid(factor: number): boolean {
	return factor > 0 && hasFloatValidDigits(factor, 17, 10);
}
